import { render, staticRenderFns } from "./ReloadIcon.vue?vue&type=template&id=2b675d0c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b675d0c')) {
      api.createRecord('2b675d0c', component.options)
    } else {
      api.reload('2b675d0c', component.options)
    }
    module.hot.accept("./ReloadIcon.vue?vue&type=template&id=2b675d0c", function () {
      api.rerender('2b675d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/status/ReloadIcon.vue"
export default component.exports